<!-- =========================================================================================
    File Name: UserProfile.vue
    Description: user profile sidebar
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="parentx-demo-2">

    <vs-sidebar :hidden-background="false" :position-right="!isLoggedInUser" class="items-no-padding" id="chat-profile-sidebar" parent="#chat-app" v-model="activeLocal">

      <div class="header-sidebar relative flex flex-col p-0" slot="header">
        <feather-icon @click="$emit('closeProfileSidebar', false)" icon="XIcon" svgClasses="m-2 cursor-pointer absolute top-0 right-0"></feather-icon>


        <div class="relative inline-flex mx-auto mb-5 mt-6">
          <vs-avatar :src="chatUser.photoURL" class="m-0 border-white border-2 border-solid shadow-md" size="70px"/>
          <div :class="'bg-' + statusColor" class="h-5 w-5 border-white border-2 border-solid rounded-full absolute right-0 bottom-0"></div>
        </div>

        <h4 class="mr-2 self-center">{{ chatUser.displayName }}</h4>
      </div>

      <component :is="scrollbarTag" :key="$vs.rtl" :settings="settings" class="scroll-area">
        <div class="p-8">

          <h6 :class="{'ml-4': isLoggedInUser}" class="mb-2">About</h6>
          <vs-textarea :counter-danger.sync="counterDanger" class="mb-10" counter="120" maxlength="120" rows="5" v-if="isLoggedInUser" v-model="about"/>
          <p v-else>{{ chatUser.about }}</p>

          <div class="userProfile__status" v-if="isLoggedInUser">
            <h6 class="mb-4">Status</h6>
            <ul>
              <li class="mb-2">
                <vs-radio color="success" v-model="status" vs-value="online">Active</vs-radio>
              </li>
              <li class="mb-2">
                <vs-radio color="danger" v-model="status" vs-value="do not disturb">Do Not Disturb</vs-radio>
              </li>
              <li class="mb-2">
                <vs-radio color="warning" v-model="status" vs-value="away">Away</vs-radio>
              </li>
              <li class="mb-2">
                <vs-radio color="grey" v-model="status" vs-value="offline">Offline</vs-radio>
              </li>
            </ul>
          </div>
        </div>
      </component>
    </vs-sidebar>
  </div>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar'

  export default {
    props:      {
      userId:         {
        type:     Number,
        required: true
      },
      active:         {
        type:     Boolean,
        required: true
      },
      isLoggedInUser: {
        type:     Boolean,
        required: true
      }
    },
    data ()
    {
      return {
        counterDanger: false,
        settings:      { // perfectscrollbar settings
          maxScrollbarLength: 60,
          wheelSpeed:         .60
        }
      }
    },
    computed:   {
      chatUser ()
      {
        return this.$store.getters['chat/chatUser'](this.userId)
      },
      activeLocal: {
        get () { return this.active },
        set (value) { this.$emit('closeProfileSidebar', value) }
      },
      about:       {
        get () { return this.chatUser.about },
        set (value) { this.$store.dispatch('updateUserInfo', {about: value}) }
      },
      status:      {
        get () { return this.chatUser.status },
        set (value) { this.$store.dispatch('updateUserInfo', {status: value}) }
      },
      statusColor ()
      {
        const userStatus = this.chatUser.status

        if (userStatus === 'online')
        {
          return 'success'
        } else if (userStatus === 'do not disturb')
        {
          return 'danger'
        } else if (userStatus === 'away')
        {
          return 'warning'
        } else
        {
          return 'grey'
        }
      },
      scrollbarTag ()
      {
        return this.$store.getters.scrollbarTag
      }
    },
    components: {
      VuePerfectScrollbar
    }
  }

</script>

